// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import api from './api/'

import ElementUI from 'element-ui'
import './style/element-variables.scss'
import 'font-awesome/css/font-awesome.css'
import './assets/iconfont/iconfont.css'
import './assets/iconfont/iconfont'
import { setPoint } from './utils/setPoint.js'
Vue.prototype.$setPoint = setPoint
import SelectModel from '@/components/selectAutoModel/index.vue'
// 事件总线
let eventBus = new Vue()
Vue.prototype.$bus = eventBus
//全局css
import './style/common.scss';
import nodeLeft from '@/pages/recommend/automaticPutin/intellPromotion/component/nodeItem/nodeLeft'
import costDialog from '@/pages/recommend/automaticPutin/intellPromotion/component/nodeItem/costDialog'

//注册为全局组件
Vue.component('SelectModel',SelectModel)

//路由和请求拦截器
import './intercept.js'

import '@/style/font.scss';
//数值转化
import * as tool from './utils/tool.js'
// 指令
import * as directives from './directives/directives'
import moment from 'moment'

// 
Vue.prototype.$moment = moment

// 注册自定义指令
Object.keys(directives).forEach(key => {
  Vue.directive(key, directives[key])
})

global.tool = tool;
Object.keys(tool).forEach(key => {
  Vue.filter(key, tool[key])
})
// Vue.config.devtools = true
Vue.use(ElementUI, { size: 'small' });



global.api = api;

Vue.config.productionTip = false

//页面刷新全局函数  在需要刷新的地方直接调用  this.contentReload()
//一级菜单刷新(顶部菜单)
Vue.prototype.contentReload = function () {
  this.$store.dispatch('reload/changeContentReload', false)
  this.$nextTick(() => {
    this.$store.dispatch('reload/changeContentReload', true)
  })
}
//子菜单刷新(左侧菜单)  this.rightReload()
Vue.prototype.rightReload = function () {
  this.$store.dispatch('reload/changeRightReload', false)
  this.$nextTick(() => {
    this.$store.dispatch('reload/changeRightReload', true)
  })
}
Vue.component("nodeLeft", nodeLeft)
Vue.component("costDialog", costDialog)

// Vue.component("downloadExcel", JsonExcel);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})









// WEBPACK FOOTER //
// ./src/main.js